/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import styled from "@emotion/styled";
import add_comma from "../lib/add_comma";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function ReservationClassEdit(props) {
  const { login, onClose, seq, tcidParent, setTcidParent } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState(tcidParent);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [showProductSearch, setShowProductSearch] = useState(false);
  const [amount, setAmount] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [pid, setPid] = useState("");
  const [tmcd, setTmcd] = useState("");

  const [cid, setCid] = useState("");
  const [tcd, setTcd] = useState("");
  const [tdate, setTdate] = useState(null);
  const [shour, setShour] = useState('');
  const [ehour, setEhour] = useState('');
  const [className, setClassName] = useState('');
  const [classMemo, setClassMemo] = useState("");
  const [maxCount, setMaxCount] = useState(0);
  const [hours, setHours] = useState([
    { id: 0, name: "09:00" },
    { id: 1, name: "10:00" },
    { id: 2, name: "11:00" },
  ]);
  const [teacher, setTeacher] = useState([]);
  const [tid, setTid] = useState('');
  const [tname, setTname] = useState('');

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onCalendarChange = (dt) => {
    setData((state) => {
      return { ...state, on_date: moment(dt).format("YYYY-MM-DD") };
    });
  };

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
    tid: "",
    tdate: '',
    shour: "",
    ehour: "",
    class_name: "",
    class_memo: "",
    max_count: 0,
    pt_type: ''
  });

  const onSubmit = async () => {

    let result = await axios.post(
      configState.api + "/gympass_admin/class_edit",
      {
        ...data,
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClose();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/class_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );
    if (result.data.success === 1) {
      setData({
        on_date: result.data.row.on_date,
        shour: result.data.row.shour,
        ehour: result.data.row.ehour,
        class_name: result.data.row.className,
        class_memo: result.data.row.classMemo,
        max_count: result.data.row.maxCount,
        pt_type: result.data.row.pt_type,
        tcd: result.data.row.tcd
      });
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  useEffect(() => {
    load_data();
    load_reservation_hours();
    load_teacher_select();
  }, [tcid, tcidParent]);

  const load_reservation_hours = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_hours",
      {
        token: token,
        cid: login.cid,
        mcd: login.mcd,
        level: login.level,
      }
    );
    if (result.data.success === 1) {
      setHours(result.data.rows);
    }
  };

  const load_teacher_select = async () => {
    pr('load_teacher_select');
    let result = await axios.post(
      configState.api + "/gympass_admin/class_edit_teacher_select",
      {
        token: token,
        // cid: tcid,
        mcd: login.mcd,
        level: login.level,
        tcid: tcid,
      }
    );

    if (result.data.success === 1) {
      setTeacher(result.data.rows);
    }
    // console.log(teacher)
  };

  const onChangeMethod = (e) => {
    // const onChangeMethod = (e) => {
    //   setMethod(e.target.value);
    // }
  }

  return (
    <Box>

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >

        {/* 강사명 */}
        {/* <Box sx={{ mt: 2, display: 'flex', fontSize: '16px' }}>
          강사명 : {tname}
        </Box> */}

        {/* 수업구분 */}
        <Box mt={1}>
          <FormControl>
            <InputLabel id="class-gubun">수업구분</InputLabel>
            <Select
              id="class-gubun"
              name="pt_type"
              label="시작시간"
              size="small"
              value={data.pt_type}
              onChange={onHandleData}
              sx={{ width: 200 }}
            >
              <MenuItem value="GX">그룹수업</MenuItem>
              <MenuItem value="PT_TRAINER">PT트레이너</MenuItem>
              <MenuItem value="PT_MANAGER">PT점장</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* 시작일 */}
        <Box sx={{ mt: 2, display: "flex" }}>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
              <DatePicker
                allowSameDateSelection={true}
                label="수업일"
                value={data.on_date}
                onChange={onCalendarChange}
                renderInput={(params) => <TextField size="small" {...params} />}
                inputFormat={"yyyy.MM.dd"}
                autoComplete="off"
              />
            </LocalizationProvider>
          </Box>
        </Box>

        {/* 수업시간 */}
        <Box display="flex" alignItems="center">
          <FormControl
            css={css`
              margin-top: 10px;
            `}
          >
            <InputLabel id="select-teacher-label">시작시간</InputLabel>
            <Select
              name="shour"
              labelId="select-teacher-label"
              css={css`
                width: 120px;
              `}
              label="가맹점"
              size="small"
              value={data.shour}
              onChange={onHandleData}
            >
              {hours.map((item, index) => {
                return (
                  <MenuItem value={item.name} key={index}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <Box sx={{ ml: 1, mr: 1 }}> - </Box>
          <FormControl
            css={css`
              margin-top: 10px;
            `}
          >
            <InputLabel id="select-teacher-label">종료시간</InputLabel>
            <Select
              name="ehour"
              labelId="select-teacher-label"
              css={css`
                width: 120px;
              `}
              label="가맹점"
              size="small"
              value={data.ehour}
              onChange={onHandleData}
            >
              {hours.map((item, index) => {
                return (
                  <MenuItem value={item.name} key={index}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>

        {/* 수업명 */}
        <FormControl sx={{ mt: 1 }}>
          <TextField
            name="class_name"
            sx={{ width: 400 }}
            value={data.class_name}
            onChange={onHandleData}
            size="small"
            label="수업명"
            autoComplete="off"
          ></TextField>
        </FormControl>

        {/* 수업내용 */}
        <FormControl sx={{ mt: 1 }}>
          <TextField
            name='class_memo'
            sx={{ width: 400 }}
            onChange={onHandleData}
            value={data.class_memo}
            size='small'
            label='수업내용'
            multiline
            rows={3}>
          </TextField>
        </FormControl>

        {/* 인원 */}
        <FormControl sx={{ mt: 1 }}>
          <TextField
            name="max_count"
            sx={{ width: 100 }}
            onChange={onHandleData}
            size="small"
            label="허용 인원"
            autoComplete="off"
            value={data.max_count}
          ></TextField>
        </FormControl>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => onClose()}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ReservationClassEdit;
